



















import { computed, defineComponent } from "@vue/composition-api";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import config from "@/config";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "VerificationNotification",
  components: { BaseIcon },
  props: {
    user: {
      type: Object as () => UserPublicData,
      required: false,
    },
  },
  setup(props) {
    const { authUser, userVerificationStatus } = useAuthUser();
    const isAuthor = computed(() => authUser.value && props.user && authUser.value.id === props.user.id);
    const everyoneCanPost = computed(() => config.featureEveryoneCanPost);
    const show = computed(
      () => isAuthor.value && userVerificationStatus.value === UserVerificationStatus.WAITING_FOR_APPROVAL
    );
    return {
      show,
      everyoneCanPost,
    };
  },
});
